"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M10 3h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1m2 5c.55 0 1 .45 1 1v1.17l6.98 6.98C20.63 15.91 21 14.5 21 13c0-2.12-.74-4.07-1.97-5.61l.75-.75c.38-.38.39-1.01 0-1.4l-.01-.01c-.39-.39-1.01-.38-1.4 0l-.75.75C16.07 4.74 14.12 4 12 4c-1.48 0-2.89.38-4.13 1.04l3.36 3.36c.18-.24.45-.4.77-.4M2.1 3.51c-.39.39-.39 1.02 0 1.41l2.72 2.72C3.73 9.09 3.05 10.86 3 12.76 2.87 17.84 6.94 22 12 22c2.02 0 3.88-.67 5.38-1.79l1.69 1.69c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L3.51 3.51a.9959.9959 0 0 0-1.41 0"
}), 'TimerOffRounded');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/TimerOffRounded.js
// module id = 11967
// module chunks = 0